import dt from 'dayjs'
import * as lib from '../lib'
import { IFetchItems, IFetchRole, IRole } from '../types'

export const listRole = async (
	filter: ReturnType<typeof lib.filterSetup>,
	sort: ReturnType<typeof lib.sortSetup>,
	skip: ReturnType<typeof lib.skipSetup>,
	take: ReturnType<typeof lib.takeSetup>,
	signal: AbortSignal,
	token?: string | null,
): Promise<IFetchItems<IRole>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {
		f: filter,
		s: sort,
		skip,
		take
	}
	const uri: string = 'role'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal,
	}
	const data = await lib.fetching<IFetchItems<IFetchRole>>(uri, options)

	const rows = data?.items
		?.map((item: IFetchRole): IRole => {
			const { createdAt, updatedAt, ...row } = item
			return {
				...row,
				createdAt: dt(createdAt).toDate(),
				updatedAt: dt(updatedAt).toDate(),
			}
		})

	return {
		items: rows ?? [],
		total: data?.total ?? 0,
	}
}
